import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
  type: "success",
  Notification: false,
  message: null,
  notifications: [],
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    showNotification: {
      reducer: (state, action) => {
        // Some API interceptors dispatch this action by its type string, which
        // bypasses the action creator's prepare callback.
        const notification = {
          ...action.payload,
          id: action.payload.id ?? nanoid(),
        };

        state.notifications.push(notification);
        state.Notification = true;
        state.type = notification.type;
        state.message = notification.message;
      },
      prepare: (notification) => ({
        payload: {
          ...notification,
          id: notification.id ?? nanoid(),
        },
      }),
    },
    offNotification: (state, action) => {
      const notificationId = action.payload;

      if (notificationId) {
        state.notifications = state.notifications.filter(
          (notification) => notification.id !== notificationId
        );
      } else {
        state.notifications.shift();
      }

      const nextNotification = state.notifications[0];
      state.Notification = Boolean(nextNotification);
      state.type = nextNotification?.type ?? "success";
      state.message = nextNotification?.message ?? null;
    },
  },
});

export const { showNotification, offNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
